import * as React from 'react';
import { useSelector } from 'react-redux';
import { path, pathOr } from 'ramda';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { useMemo } from 'react';

import { QuizPersonalApplication } from '../../components/QuizPersonalApplication';
import { BackToPageContainer } from '../BackToPageContainer';
import { IBaseQuestionProps } from '../FormContainer/types/internal';
import { extraBtnsMap } from './constants/extraBtnsMap';
import { IExtraBtnProps } from './types';
import { useFormTracking } from '../../utils/useFormTracking';
import { selectIsWebview } from '../../selectors/selectIsWebview';
import { CloseWebview } from '../../components/QuizCompleteSuccess/components/CloseWebview';
import { ADDITIONAL_TEXT, DEFAULT_HELPER_TEXT, DEFAULT_TITLE } from './constants/defaults';
import { selectPickedSpecialists } from '../../selectors/selectPickedSpecialist';

export const QuizPersonalApplicationContainer: React.FC<React.PropsWithChildren<IBaseQuestionProps>> = props => {
  const isDesktop = useIsDesktop();
  const { question } = props;
  const { title, helpText } = question;
  const isWebview = useSelector(selectIsWebview);
  const pickedSpecialists = useSelector(selectPickedSpecialists);
  const completeButtonName = pathOr('', ['extra', 'completeButton'], props.question);
  const CompleteButton = path<React.ComponentType<IExtraBtnProps>>([completeButtonName], extraBtnsMap);
  const { trackCompleteButton } = useFormTracking();

  const selectedRealtors = useMemo(() => Object.values(pickedSpecialists), [pickedSpecialists]);

  /**
   * Для webview всегда показываем кнопку "Хорошо", закрывающую webview
   * На это "зашиты" мобильные приложения
   */
  const footer = isWebview ? <CloseWebview /> : CompleteButton && <CompleteButton onClick={trackCompleteButton} />;

  return (
    <QuizPersonalApplication
      realtors={selectedRealtors}
      backToPage={<BackToPageContainer />}
      title={title || DEFAULT_TITLE}
      subtitle={pathOr(DEFAULT_HELPER_TEXT, ['text'], helpText)}
      description={isDesktop ? ADDITIONAL_TEXT : ''}
      footer={footer}
    />
  );
};

QuizPersonalApplicationContainer.displayName = 'QuizPersonalApplicationContainer';
